import {createRouter, createWebHistory} from "vue-router";
import Login from '@/pages/LoginPage.vue';
import Products from '@/pages/ProductsPage.vue';
import Summary from '@/pages/SummaryPage.vue';
import Success from '@/pages/SuccessPage.vue';
import Failure from '@/pages/FailurePage.vue'
import HowToReturnPage from "@/pages/HowToReturnPage.vue";
import { withLocale, defaultLocale } from "@/locales/localization";
import { fixLocaleInUrl } from "@/locales/localization";



const bgcolor = "#F0F0F0";

const routes = [
    { path: '/', redirect: `/${defaultLocale}` }, // redirect root to default locale
    withLocale({ path: '/', name: 'LoginPage', component: Login }),
    withLocale({ path: '/products', name:'ProductsPage', component: Products, props: true, meta:{ bgColor: bgcolor } }),
    withLocale({ path: '/howToReturn', name:'HowToReturnPage', component: HowToReturnPage, meta:{ bgColor: bgcolor } }),
    withLocale({ path: '/summary', name:'SummaryPage', component: Summary, meta:{ bgColor: bgcolor } }),
    withLocale({ path: '/success', name:'SuccessPage', component: Success, meta:{ bgColor: bgcolor } }),
    withLocale({ path: '/failure', name:'FailurePage', component: Failure, meta:{ bgColor: bgcolor } }),
];

const router = createRouter({
    history: createWebHistory(), //createMemoryHistory
    routes,
});


router.beforeEach((to, from, next) => fixLocaleInUrl(to, from, next));

router.afterEach((to) => {
    document.body.style.backgroundColor = to.meta.bgColor || "white";
});


export default router;